import Vue from 'vue';

export default {

  // vvv RAUS (Vorläufer generic API)

  READY(state) {
    state.initial_data_ready = true;
  },

  /*
  // TODO: Merge new events with existings events
  MERGE_EVENTS(state, eventList) {
    // Object.keys(eventList).forEach(key => { ... })
    eventList.forEach(event => {
      Vue.set(state.events, event.id, event)
    })
  }, */

  SYNC_EVENTS_SET_ALL(state, { week, data } ) {
    console.log("[SYNC_EVENTS_SET_ALL]");
    // Same as state.events[week] = data, but reactive
    Vue.set(state.events, week, data)
  },

  /*
  Mutations to allow fast sync without waiting for the servers response.
  USE_CALENDARWEEK_BATCHES is not supported!
  */
  SYNC_EVENT_PATCH(state, { id, data }) {
    try {
      console.log("[SYNC_EVENT_PATCH]");
      let updateIndex = state.events[0].findIndex(event => event.id === id);
      Object.keys(data).forEach(key => {
        state.events[0][updateIndex][key] = data[key];
      })
    } catch (e) {
      console.warn('Bypass Sync (SYNC_EVENT_PATCH) failed.');
    }
  },

  SYNC_EVENT_ADD(state, { data }) {
    try {
      console.log("[SYNC_EVENT_ADD]");
      state.events[0].push(data)
    } catch (e) {
      console.warn('Bypass Sync (SYNC_EVENT_ADD) failed.');
    }
  },

  SYNC_EVENT_REMOVE(state, { id }) {
    try {
      console.log("[SYNC_EVENT_REMOVE]");
      let oldIndex = state.events[0].findIndex(event => event.id === id);
      return state.events[0].splice(oldIndex, 1)[0]
    } catch (e) {
      console.warn('Bypass Sync (SYNC_EVENT_REMOVE) failed.');
      return null
    }
  },

  SET_OVERRIDE_MARKERS(state, { week, data } ) {
    // Same as state.markers[week] = data, but reactive
    Vue.set(state.markers, week, data)
  },

  SET_DEFAULT_MARKERS(state, { data } ) {
    state.default_markers = data;
  },

  // ^^^^ RAUS ???

  DRAG_START(state) {
    state.is_dragging = true;
  },

  DRAG_END(state) {
    state.is_dragging = false;
  },

  SET_CURRENT_DROP_ZONE(state) {
    state.current_drop_zone = false;
  },

  /* ------------------------------------------------------------------------ */

  SET_CALENDAR_ZOOM(state, zoom) {
    state.calendar_view_settings.timeslotDuration = zoom;
  },

  SET_CALENDAR_VIEW(state, view) {
    state.calendar_view_settings.view = view;
  },

  TOOGLE_CALENDAR_NOW_INDICATOR(state, view) {
    state.calendar_view_settings.show_now_indicator =
      !state.calendar_view_settings.show_now_indicator;
  },

  SET_CALENDAR_VIEW_RANGE(state, { from_date, to_date, horizon }) {
    state.calendar_view_settings.visible_range.from_date = from_date;
    state.calendar_view_settings.visible_range.to_date = to_date;
    state.calendar_view_settings.visible_range.horizon = horizon;
  },

  SET_CALENDAR_VISIBLE_TIME(state, { min_time, max_time }) {
    state.calendar_view_settings.visible_time.min_time = min_time;
    state.calendar_view_settings.visible_time.max_time = max_time;
  },

  TOGGLE_CALENDAR_SOURCE_VIEW(state, key) {
    Vue.set(
      state.calendar_view_settings.source,
      key,
      !state.calendar_view_settings.source[key])
  },

  SHOW_CALENDAR_SOURCE_VIEW(state, key) {
    Vue.set(
      state.calendar_view_settings.source,
      key,
      true)
  },

  HIDE_CALENDAR_SOURCE_VIEW(state, key) {
    Vue.set(
      state.calendar_view_settings.source,
      key,
      false)
  },

  DEHYDRATE_VIEW_SETTINGS(state) {
    // TODO: shoudl this include from - to, or just the range?
    localStorage.setItem(
      'calendar_view_settings',
      JSON.stringify( state.calendar_view_settings )
    );
  },

  REHYDRATE_VIEW_SETTINGS(state) {
    let calendarViewSettingsJSON = localStorage.getItem('calendar_view_settings');
    let calendar_view_settings = null;
    try {
      calendar_view_settings = JSON.parse( calendarViewSettingsJSON );
    } catch ( error ) {
      console.warn("Failed to read calendar view settings from local storage:" + error);
    }
    if ( calendar_view_settings ) {
      // TODO: use deep merge
      state.calendar_view_settings = Object.assign([],
        state.calendar_view_settings,
        calendar_view_settings );

      // TODO: Use to calendar_view_settings.horizon set start end end date to:
      // start = moment.currentDate();
      // end = start.clone().add(horizon, 'days');
    }
  },

  /* ------------------------------------------------------------------------ */

  SET_ACTIVE_TIMESLOT_COLLECTION(state, value) {
    // console.log("SET_ACTIVE_TIMESLOT_COLLECTION", value);
    state.timeslot_collection_selected = value;
    state.goal_selected = null;
    state.effort_selected = null;
  },

  SET_ACTIVE_EFFORT(state, value) {
    state.timeslot_collection_selected = null;
    // Allow to select goal and effort, so don't reset goal_selected
    state.effort_selected = value;
  },

  SET_ACTIVE_GOAL(state, value) {
    state.timeslot_collection_selected = null;
    state.goal_selected = value;
    // Allow to select goal and effort, so don't reset effort_selected
  }
}
